module.exports = __webpack_public_path__ + "img/slide-01.0604aef8.png";